import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {WidgetCheckboxV0NodeDto} from '../../widget-checkbox/v0/models/widget-checkbox-v0-node.dto';
import {IoniconsFilled, IoniconsOutline, MAIL_REGEX, ND} from '@pt/pt-models';
import {WidgetHolderChooserPreviewDataV0} from './models/widget-contact-chooser-preview-v0.dto';
import { Observable } from 'rxjs';

@Component({
  selector: 'pt-widget-contact-chooser-v0-preview',
  template: `
    <ng-container *ngIf='loading; then LOADING; else PREVIEW'></ng-container>

    <ng-template #LOADING>
      Loading ...
    </ng-template>

    <ng-template #PREVIEW>

      <ng-container *ngIf='noData; then NODATA; else DATA'></ng-container>

      <ng-template #NODATA>
        <pt-widget-nodata [noDataLabel]="noDataLabel"></pt-widget-nodata>
      </ng-template>

      <ng-template #DATA>
        <table class='table table-striped table-sm'>
          <thead class='bg-secondary text-white'>
          <tr>
            <th scope='col' class='contact-chooser-preview-col'>{{ previewData?.header.col1 }}</th>
            <th scope='col' class='contact-chooser-preview-col'>{{ previewData?.header.col2 }}</th>
            <th scope='col' class='contact-chooser-preview-col'>{{ previewData?.header.col3 }}</th>
            <th scope='col' class='contact-chooser-preview-col'>{{ previewData?.header.col4 }}</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor='let row of previewData?.value'>
            <td>
              {{ row?.col1 ? row?.col1 : ND }}
              <pt-icon class='d-inline-flex text-warning ms-2'
                       *ngIf='!(row?.col1?.length > 0)'
                       [key]='IconWarning' [ngbTooltip]="'WIDGET_WARNING.REQUIRED_VALUE' | translate">
              </pt-icon>
            </td>
            <td>
              {{ row?.col2 ? row?.col2 : ND }}
            </td>
            <td>
              {{ row?.col3 ? row?.col3 : ND }}
            </td>
            <td>
              <div class="d-flex align-content-center">
                <input class="form-check-input"
                       container='body'
                       ngbTooltip="{{'TOOLTIP.USE_RESOURCE_EMAIL' | translate}}"
                       style="margin:4px 10px 0 10px"
                       type="checkbox"
                       [ngModel]='row.useReferentEmail'
                       [disabled]='true'>
                <span>{{ row?.col4 ? row?.col4 : ND }}</span>
                <pt-icon class='d-flex align-items-center text-warning ms-1'
                         [size]="16"
                         *ngIf='isInvalidMail(row?.col4) && !emailOptional'
                         [key]='IconWarning' [ngbTooltip]="'WIDGET_WARNING.REQUIRED_MAIL' | translate">
                </pt-icon>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </ng-template>
    </ng-template>
  `,
  styles: [`
    .contact-chooser-preview-col {
      width: 25%;
    }
  `]
})
export class WidgetContactChooserV0PreviewComponent implements OnChanges {
  @Input() noDataLabel?: string;

  @Input() previewData: WidgetHolderChooserPreviewDataV0;
  @Input() loading: boolean;
  @Input() emailOptional = false;

  IconWarning = IoniconsOutline.warning;

  ND = ND;
  items: WidgetCheckboxV0NodeDto[] = [];
  noData = true;

  IconInfoCircle = IoniconsFilled.infoCircle;
  IconCheckFilled = IoniconsFilled.checkbox;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.previewData) {
      this.noData = !this.previewData?.header || !(this.previewData?.value?.length > 0);
    }
  }


  isInvalidMail(email: string): boolean {
    return !email?.match(MAIL_REGEX);
  }
}
